import { Branch, branchNameMap } from "./Branch.js";

export type PickUpBranch = Exclude<Branch, Branch.Central>;

export function getPickUpBranches(): PickUpBranch[] {
	const branches: PickUpBranch[] = [];
	for (const branch of Object.values(Branch)) {
		if (branch !== Branch.Central) {
			branches.push(branch);
		}
	}
	return branches;
}

export function isPickUpBranch(branch: Branch): branch is PickUpBranch {
	return (getPickUpBranches() as Branch[]).includes(branch);
}

const { [Branch.Central]: _, ...branchesWithoutCentral } = branchNameMap;

export const pickUpBranchMap = branchesWithoutCentral;
